module.exports = __webpack_public_path__ + "static/media/ic_wcag_text_medium.9d5b1c6a.svg";